import { defaultDarkTheme } from 'react-admin';
import { createTheme } from '@mui/material/styles';


const modernDarkTheme = createTheme({
  ...defaultDarkTheme,
  palette: {
    ...defaultDarkTheme.palette,
    primary: {
      main: '#90caf9', // Light blue
    },
    secondary: {
      main: '#f48fb1', // Pink
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
  components: {
    ...defaultDarkTheme.components,
    MuiToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1f1f1f',
          borderTop: '1px solid #333',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1e1e1e', // Same as paper background
          borderRight: '1px solid #333',
          height: '100%', // Ensure drawer takes full height
          minHeight: '100vh', // Minimum height to fill viewport
          '&.MuiDrawer-paperAnchorLeft': {
            backgroundColor: '#1e1e1e', // Ensure left drawer has consistent background
            height: '100%',
            minHeight: '100vh',
          },
        },
        root: {
          '& .MuiPaper-root': {
            minHeight: '100vh', // Ensure drawer paper fills viewport
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#1e1e1e',
          '&.RaLayout-content': {
            backgroundColor: '#121212', // Main content area
          },
          '&.RaSidebar-fixed': {
            backgroundColor: '#1e1e1e', // React Admin sidebar class
            height: '100vh', // Fixed viewport height
            maxHeight: '100vh', // Prevent overflow
            overflow: 'hidden', // Hide overflow on container
            display: 'flex',
            flexDirection: 'column',
          },
          '&.RaSidebar-paper': {
            backgroundColor: '#1e1e1e', // React Admin sidebar paper class
            height: '100vh',
            maxHeight: '100vh',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          },
          '&.RaLayoutWithSidebar-sidebar': {
            backgroundColor: '#1e1e1e',
            height: '100vh',
            maxHeight: '100vh',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          },
          // Target Paper components inside sidebar (like accordion content)
          '.RaSidebar-fixed .MuiPaper-root, .RaSidebar-paper .MuiPaper-root': {
            maxHeight: '200px',
            overflowY: 'auto',
            backgroundColor: '#1e1e1e',
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          '&.RaMenu-list': {
            backgroundColor: '#1e1e1e', // React Admin menu list
            flex: '1 1 auto', // Allow the menu to grow and shrink
            overflowY: 'auto', // Make menu scrollable when content overflows
            overflowX: 'hidden', // Hide horizontal overflow
            maxHeight: '100%', // Prevent the menu from exceeding container height
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          '&.RaMenuItemLink-active': {
            backgroundColor: 'rgba(144, 202, 249, 0.12)', // Active menu item with primary color
          },
        },
      },
    },
    MuiCollapse: {
      styleOverrides: {
        root: {
          // Constrain accordion content in sidebar menus
          '&.MuiCollapse-entered': {
            maxHeight: '200px', // Much more restrictive height limit
            overflowY: 'auto', // Make accordion content scrollable if needed
          },
          // Also target the wrapper and wrapperInner classes
          '& .MuiCollapse-wrapper': {
            maxHeight: '200px',
            overflowY: 'auto',
          },
          '& .MuiCollapse-wrapperInner': {
            maxHeight: '200px',
            overflowY: 'auto',
          },
        },
      },
    },
    // Simple body background fix for dark theme
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#121212', // Match the dark theme background
        },
      },
    },
  },
});

export default modernDarkTheme;